import type { Prontidao } from "@/api/contrato";
import { Pilula } from "@/componentes/PilulaDeSituacao";

/*
 * O selo do cedente, igual na lista e na página (spec `pendencias-do-cedente`).
 *
 * Quem decide é o servidor: a tela só escolhe o texto. Aviso não conta, e por isso
 * `N pendências` são as bloqueantes. O selo fica tingido, porque a forma sólida é
 * exclusiva do indeterminado (doc 06a §3.2).
 */
export function SeloDoCedente({
  status,
  pronto,
  bloqueantes,
}: {
  /** `status` da pessoa: bloqueado vence a contagem. */
  status: string;
  pronto: boolean;
  bloqueantes: number;
}) {
  if (status === "bloqueado") return <Pilula matiz="encerrado">bloqueado</Pilula>;
  if (pronto) return <Pilula matiz="pago">pronto para emitir</Pilula>;

  return (
    <Pilula matiz="falha">{bloqueantes === 1 ? "1 pendência" : `${bloqueantes} pendências`}</Pilula>
  );
}

/** A contagem que `GET /pessoas` traz pronta, para quem tem a lista de pendências. */
export function bloqueantesDe(prontidao: Prontidao): number {
  return prontidao.pendencias.filter((pendencia) => pendencia.bloqueia).length;
}
